function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlushWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.81,21,45.9,42.29a1.15,1.15,0,0,0,1.62-.19l2.79-3.56a1.15,1.15,0,0,0-.19-1.62L23,15.64a1.15,1.15,0,0,0-1.61.19l-2.8,3.56A1.16,1.16,0,0,0,18.81,21Zm3.71-2.85L47.79,38l-1.37,1.75L21.14,19.91Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.41,42.45H13.49a1.15,1.15,0,0,0-1.15,1.15v3.55a19.87,19.87,0,0,0,6.09,14.1,25.67,25.67,0,0,0,13.43,6.8l.47.09v5.21a1.16,1.16,0,0,0,1.15,1.15H61.41a1.15,1.15,0,0,0,1.15-1.15V43.6A1.15,1.15,0,0,0,61.41,42.45ZM60.26,72.2H34.63V67l0-.13,0-.12-.11-.22-.08-.12-.13-.13-.11-.09-.1-.06-.15-.07L33.66,66c-10.86-1.36-19-9.47-19-18.86v-2.4H60.26Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.83,9.33H53a1.15,1.15,0,0,0-1.15,1.15V38.89A1.15,1.15,0,0,0,53,40H63c4,0,7.44-3.38,8-7.86V10.48A1.15,1.15,0,0,0,69.83,9.33ZM68.68,31.91c-.45,3.36-2.9,5.83-5.7,5.83H54.14V11.64H68.68Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,42.46l.12-.67a6.52,6.52,0,0,0,.07-.88,5.28,5.28,0,1,0-10.47.88l.11.67m5.09-5.26a3.69,3.69,0,0,1,3.52,4.86l-.12.4h-6.8l-.13-.4a3.72,3.72,0,0,1,3.53-4.86Z",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.35px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.85,37.2a3.27,3.27,0,1,0-3.27-3.26A3.27,3.27,0,0,0,10.85,37.2Zm0-5.46a2.2,2.2,0,1,1-2.2,2.2A2.2,2.2,0,0,1,10.85,31.74Z",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.27,28.11A2.08,2.08,0,1,0,15.2,26,2.08,2.08,0,0,0,17.27,28.11Zm0-3.33A1.26,1.26,0,1,1,16,26,1.25,1.25,0,0,1,17.27,24.78Z",
    style: {
      fill: "currentColor",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlushWater);
export default __webpack_public_path__ + "static/media/flush_water.a23a829ca83e84462187f772d89b9021.svg";
export { ForwardRef as ReactComponent };